import { RootState } from '../index'

export const selectAddresses = (state: RootState) => state.addresses
export const selectCustomerOrderCount = (state: RootState) => state.customers.orderCount
export const selectCustomersSearch = (state: RootState) => state.customers
